export default __webpack_public_path__ + "static/fonts/TradeGothicLTStd-Cn18.3d2095d.woff2";